<template>
  <section class="entrance">
    <header class="entrance__header">
      <h2 class="entrance__title">
        <span v-html="title" />
        <small v-if="subtitle">{{ subtitle }}</small>
      </h2>
    </header>

    <router-link
      v-if="linkInternal"
      :to="linkInternal"
    >
      <icon
        v-if="icon"
        :type="icon"
        class="entrance__icon"
      />
    </router-link>

    <a
      v-if="linkExternal"
      :href="linkExternal"
    >
      <icon
        v-if="icon"
        :type="icon"
        class="entrance__icon"
      />
    </a>

    <div class="entrance__content">
      <h3 class="entrance__contenttitle">
        {{ contenttitle }}
      </h3>
      <slot name="content" />
    </div>

    <footer class="entrance__footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
import icon from './icon.vue'

export default {
  name: 'CEntrance',

  components: {
    icon
  },

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: undefined
    },
    contenttitle: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    linkInternal: {
      type: String,
      default: undefined
    },
    linkExternal: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.entrance {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $gutter-sm;

  text-align: center;

  background-color: #fff;

  @media (min-width: $breakpoint-md) {
    padding: $gutter-md;
  }
}

.entrance__header {
  max-width: 100%; // Fix IE flexbox text overflow
  margin-bottom: $gutter-sm;

  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-md;
  }
}

.entrance__title {
  font-size: 1.375em;
  line-height: 1.2;
  color: $color-secondary-dark;

  // Prevent long words from overflowing
  word-wrap: break-word;
  hyphens: auto;

  small {
    display: block;
    margin-top: 0.5em;

    font-size: 0.625em;
    font-weight: 500;
  }

  @media (min-width: $breakpoint-md) {
    min-height: 3.25rem;
  }
}

.entrance__icon {
  display: none;
  max-width: 100%;

  color: $color-secondary-dark;

  @media (min-width: $breakpoint-lg) {
    display: block;
    margin-bottom: $gutter-md;
    font-size: 6em;
  }

  @media (min-width: $breakpoint-xl) {
    font-size: 8em;
  }
}

.entrance__content {
  display: block;
  flex-grow: 1;
  max-width: 100%; // Fix IE flexbox text overflow
  margin-bottom: $gutter-sm;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  @media (min-width: $breakpoint-md) {
    display: block;
    margin-bottom: $gutter-md;
  }
}

.entrance__contenttitle {
  margin-bottom: $gutter-xs;

  font-size: 1.25em;
  font-weight: 600;
}

.entrance__footer {
  max-width: 100%; // Fix IE flexbox text overflow

  .payment-methods {
    display: none;
  }

  @media (min-width: $breakpoint-lg) {
    .payment-methods {
      display: block;
    }
  }
}
</style>
